import { classNameGenerator, clsx } from "@/utils"
import styles from "./InstructorDetails.module.scss"
import Typography from "@/foundation/Typography/V2"
import { Image, SVGSprite } from "@/components/Atoms"
import ReactReadMoreReadLess from "react-read-more-read-less";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { useCallback, useEffect, useState } from "react";
import * as actions from "@/redux/BootCampReducer";


const InstructorDetails = () => {
    const cls = classNameGenerator(styles)
    const dispatch = useAppDispatch();
    const [isPageLoaded,setIsPageLoaded] = useState(true)    
    const { isLoading: dataLoading, data } = useAppSelector((state) => state.bootCamp);

    if (!data?.instructorProfile)
        return <></>

    useEffect(() => {
        setIsPageLoaded(dataLoading)
    },[dataLoading])

    const { currencySymbol, price } = data?.packData || {};
    const { discount } = data?.heroSection?.offerSection
    const { instructorDetails } = data
    const {
        hideBottomSection = false,
        hideShyftSectionInMobile = false,
        style
    } = instructorDetails || {}

    const setShowBookSlotModal = useCallback(
        (value: any) => {
            dispatch(actions.setShowBookSlotModal(value));
        },
        [dispatch]
    );

    return (
        <section id="InstructorDetail">
            <div className={cls("detailsContainer")}>
                <div className={cls("detailsWrapper")}>
                    <div
                        className={cls("topSection")}
                        style={style}
                    >
                        <div className={cls("left")}>
                            <Typography variant="heading3" className={cls("instHeading")}>
                                About our instructor
                            </Typography>
                            <div className={cls("instructor")}>
                                <div className={cls("profileWrapper")}>
                                    <Image
                                        src={data?.instructorProfile[0].image} alt="instructor profile"
                                    />
                                </div>
                                <div className={cls("details")}>
                                    <Typography variant="heading3" className={cls("label")}>
                                        {data?.instructorProfile[0].title}
                                    </Typography>
                                    <div className={cls("review")}>
                                        <ReactReadMoreReadLess
                                            charLimit={100}
                                            readMoreText={"Read more ▼"}
                                            readLessText={"Read less ▲"}
                                        >
                                            {data?.instructorProfile[0].description}
                                        </ReactReadMoreReadLess>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={clsx(cls("right"),hideShyftSectionInMobile ? cls("mobileHide"):"")}>
                            <Typography variant="heading3" className={cls("label")}>
                                About Shyft
                            </Typography>
                            <div className={cls("instructor")}>
                                <div className={cls("profileWrapper")}>
                                    <Image
                                        src={data?.instructorProfile[1].image}
                                        alt="instructor profile"
                                    />
                                </div>
                                <div className={cls("details")}>
                                    <Typography variant="heading3" className={cls("description")}
                                        dangerouslySetInnerHTML={{ __html: data?.instructorProfile[1].description }}
                                    />
                                    <Typography
                                        variant="link1"
                                        className={cls("link")}
                                        href="https://www.betheshyft.com"
                                        target="_blank"
                                    >
                                        Visit Shyft
                                        <SVGSprite
                                            icon="icon-arrow-up-right-blue"
                                            className={cls("icon")}
                                        />
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!hideBottomSection && <div className={cls("bottomSection")}>
                        <Typography variant="heading3" className={cls("heading")}>
                            Don't miss the opportunity to transform your yoga teaching and practice.
                        </Typography>
                        <div className={cls("rightSection")}>
                            <div className={cls("top")}>
                                <SVGSprite
                                    className={cls("icon")}
                                    icon={"icon-green-star"}
                                />
                                <span className={cls("discount")}>{discount}</span>
                                <Typography
                                    variant="heading4"
                                    className={cls("text")}
                                    dangerouslySetInnerHTML={{ __html: "Early bird offer" }}
                                />
                            </div>
                            <button
                                type="button"
                                className={cls("heroCtaButton")}
                                onClick={() =>
                                    setShowBookSlotModal({
                                        packageData: data?.packData,
                                        showSubtitle: true,
                                    })
                                }
                                disabled={isPageLoaded}
                            >
                                <span className={cls("heroCtaButtonText")}
                                    dangerouslySetInnerHTML={{
                                        __html: `Enroll now for ${price > 0 ? `${currencySymbol} ${price}` : "Free!"}`,
                                    }}
                                />
                                <span>{arrowIcon}</span>
                            </button>
                        </div>
                    </div>}
                </div>
            </div>
        </section>
    )
}

export default InstructorDetails;

const arrowIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
    >
        <path
            d="M6.5 13L10.5 9L6.5 5"
            stroke="#ffffff"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);